module.exports = "/_next/static/images/b8037223ae58876aa0ff61ac1d826fe9-lock.svg.webp";